import LoadBriefForm from './loadBriefForm';

export default LoadBriefForm;